import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-purple-800 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">AI</span>
              </div>
              <span className="ml-2 text-xl font-bold">短剧创作助手</span>
            </div>
            <p className="text-gray-400 mb-4">
              面向短视频创作者的AI短剧生产力工具，帮助你低成本高效率生成剧本与分镜，提供语音/画面生成的"一站式流水线"。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">微信</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.2,13.6C8.2,14.5,7.4,15.2,6.5,15.2C5.6,15.2,4.8,14.5,4.8,13.6C4.8,12.7,5.6,12,6.5,12C7.4,12,8.2,12.7,8.2,13.6M16.5,15.2C15.6,15.2,14.8,14.5,14.8,13.6C14.8,12.7,15.6,12,16.5,12C17.4,12,18.2,12.7,18.2,13.6C18.2,14.5,17.4,15.2,16.5,15.2M15.3,3.1C13.1,1.7,10.3,1,7.5,1C4.7,1,1.9,1.7,0,3.1V20.9C1.9,22.3,4.7,23,7.5,23C10.3,23,13.1,22.3,15.3,20.9V3.1M15.3,19.2C13.5,20.2,11.1,20.8,8.6,20.8C6.1,20.8,3.7,20.2,1.9,19.2V4.8C3.7,5.8,6.1,6.4,8.6,6.4C11.1,6.4,13.5,5.8,15.3,4.8V19.2Z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">微博</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M10.4,17.2c-4.3,0.2-7.7-3-7.9-7.3c-0.2-4.3,3-7.7,7.3-7.9c4.3-0.2,7.7,3,7.9,7.3C17.9,13.6,14.7,17,10.4,17.2 M20.7,8.8c-0.1-0.6-0.3-1.2-0.5-1.7c-0.1-0.3-0.3-0.6-0.5-0.8c-0.4-0.5-1-0.8-1.7-0.8c-0.7,0-1.3,0.3-1.7,0.8c-0.2,0.3-0.4,0.5-0.5,0.8c-0.2,0.5-0.4,1.1-0.5,1.7c-0.1,0.6-0.2,1.2-0.2,1.8c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.2,0.5,1.7c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.5,1,0.8,1.7,0.8c0.7,0,1.3-0.3,1.7-0.8c0.2-0.3,0.4-0.5,0.5-0.8c0.2-0.5,0.4-1.1,0.5-1.7c0.1-0.6,0.2-1.2,0.2-1.8C20.9,10,20.8,9.4,20.7,8.8 M12.8,13.5c-0.4,0.3-0.9,0.5-1.4,0.5c-0.5,0-1-0.2-1.4-0.5c-0.4-0.3-0.7-0.8-0.9-1.3c-0.2-0.5-0.3-1.1-0.3-1.7c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.5-1,0.9-1.3c0.4-0.3,0.9-0.5,1.4-0.5c0.5,0,1,0.2,1.4,0.5c0.4,0.3,0.7,0.8,0.9,1.3c0.2,0.5,0.3,1.1,0.3,1.7c0,0.6-0.1,1.2-0.3,1.7C13.5,12.7,13.2,13.2,12.8,13.5 M21.2,8.6c-0.1-0.7-0.4-1.4-0.7-2c-0.1-0.3-0.3-0.6-0.5-0.9c-0.5-0.6-1.2-0.9-1.9-0.9c-0.7,0-1.4,0.3-1.9,0.9c-0.2,0.3-0.4,0.6-0.5,0.9c-0.3,0.6-0.5,1.3-0.7,2c-0.1,0.7-0.2,1.4-0.2,2.1c0,0.7,0.1,1.4,0.2,2.1c0.1,0.7,0.4,1.4,0.7,2c0.1,0.3,0.3,0.6,0.5,0.9c0.5,0.6,1.2,0.9,1.9,0.9c0.7,0,1.4-0.3,1.9-0.9c0.2-0.3,0.4-0.6,0.5-0.9c0.3-0.6,0.5-1.3,0.7-2c0.1-0.7,0.2-1.4,0.2-2.1C21.4,10,21.3,9.3,21.2,8.6"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              产品功能
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/create" className="text-gray-400 hover:text-white transition-colors">
                  AI剧本生成
                </Link>
              </li>
              <li>
                <Link to="/create/characters" className="text-gray-400 hover:text-white transition-colors">
                  角色设定
                </Link>
              </li>
              <li>
                <Link to="/create/storyboard" className="text-gray-400 hover:text-white transition-colors">
                  分镜设计
                </Link>
              </li>
              <li>
                <Link to="/create/editor" className="text-gray-400 hover:text-white transition-colors">
                  文本编辑
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              资源中心
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/resources/templates" className="text-gray-400 hover:text-white transition-colors">
                  模板库
                </Link>
              </li>
              <li>
                <Link to="/resources/characters" className="text-gray-400 hover:text-white transition-colors">
                  角色库
                </Link>
              </li>
              <li>
                <Link to="/resources/scenes" className="text-gray-400 hover:text-white transition-colors">
                  场景库
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors">
                  帮助中心
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 AI短剧创作助手. 保留所有权利.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                隐私政策
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                服务条款
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;